import { getViaAuth, responseValidator } from "../../apis/api";
import { API } from "../../apis";
import { DefaultOptionType } from "antd/es/select";
import { Level } from "../domain";

export const getAllLevelsAsSelectOption = (setloader: any, setdata: any) => {
    setloader(true);
    getViaAuth(API.users.levels).then((response: any) => {
        setloader(false);
        const allData: DefaultOptionType[] = [];
        if (responseValidator(response.status)) {
            response?.value?.map((level: Level) => {
                allData.push({
                    value: level?.uniqueName?.id || 0,
                    label: level.uniqueName.title || "",
                });
            });
        }
        setdata(allData);
    });
};